export default "__VITE_ASSET__CMl3eiT3__";